<template>
    <div class="vue-avatar--responsive-wrapper">
        <Avatar
                :username="username"
                :initials="initials"
                :backgroundColor="backgroundColor"
                :color="color"
                :customStyle="customStyle"
                :src="src"
                :rounded="rounded"
                :lighten="lighten"
                :size="width"
                v-if="width"
                @avatar-initials="onAvatarInitials"
        />
    </div>
</template>

<script>
import throttle from 'lodash.throttle';
import ResizeObserver from 'resize-observer-polyfill';
import Avatar from 'vue-avatar/src/Avatar';

export default {
  name: 'responsive-avatar',
  components: {
    Avatar,
  },

  // Validation is performed by the child component
  props: ['username', 'initials', 'backgroundColor', 'color', 'customStyle', 'src', 'rounded', 'lighten'],

  data() {
    return {
      width: 0,
      height: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const handleResize = throttle(entries => {
        const contentRectangle = entries[0].contentRect;
        this.width = contentRectangle.width;
        this.height = contentRectangle.height;
      }, 200);

      const observer = new ResizeObserver(handleResize);
      if (this.$el instanceof Element) {
        observer.observe(this.$el);
      }
    });
  },

  computed: {},

  methods: {
    onAvatarInitials(...params) {
      this.$emit('avatar-initials', ...params);
    }
  },
};
</script>
